import { render, staticRenderFns } from "./brandbar_admin.vue?vue&type=template&id=28a4a110&scoped=true&"
import script from "./brandbar_admin.vue?vue&type=script&lang=js&"
export * from "./brandbar_admin.vue?vue&type=script&lang=js&"
import style0 from "./brandbar_admin.vue?vue&type=style&index=0&id=28a4a110&prod&lang=scss&scoped=true&"
import style1 from "./brandbar_admin.vue?vue&type=style&index=1&id=28a4a110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a4a110",
  null
  
)

export default component.exports